(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/interaction/scCommentsButton/template', '<button class="comment-button" data-ng-click="action()">\n' + '  <i class="fa fa-comment-o comment-button_icon"></i>\n' + '  <span class="comment-button_count" data-ng-show="showCount">\n' + '    {{commentable.comments_count}}\n' + '  </span>\n' + '</button>\n' + '');
}]);
})();